import { TaskMessageType } from "@fixa/notifications";

export function isTaskNotificationEnabled(type: string): boolean {
  switch (type) {
    case TaskMessageType.TaskMessageAssignedUser:
    case TaskMessageType.TaskMessageAssignedTeam:
    case TaskMessageType.TaskMessageCreatorTaskStatusCompleted:
    case TaskMessageType.TaskMessageCreatorTaskStatusClosed:
    case TaskMessageType.TaskMessageCreatorAssignedUser:
    case TaskMessageType.TaskMessageCreatorAssignedTeam:
    case TaskMessageType.TaskMessageCreatorUserPickup:
      return true;

    case TaskMessageType.TaskMessageCreatorSeriesEnd:
    case TaskMessageType.TaskMessageCreatorSeriesUpdate:
    case TaskMessageType.TaskMessageCreatorSeriesClose:
      return false;

    default:
      return true; // TODO: Change to false in July 2026 so we per default does not render unsupported notifications
  }
}
